// test1397
(1397 && 0);
